import React, { useState } from 'react';
import './fashionphotoshoot.css';

const shootData = [
  {
    id: 1,
    title: 'Monochrome Silhouette',
    category: 'Editorial',
    image: 'https://images.unsplash.com/photo-1509631179647-0177331693ae?auto=format&fit=crop&w=900&q=80',
    model: 'Elena Rostova',
    location: 'Studio 4B, Paris',
  },
  {
    id: 2,
    title: 'Autumn Velvet',
    category: 'Haute Couture',
    image: 'https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?auto=format&fit=crop&w=900&q=80',
    model: 'Sasha Chen',
    location: 'SoHo, New York',
  },
  {
    id: 3,
    title: 'Cyberpunk Minimal',
    category: 'Streetwear',
    image: 'https://images.unsplash.com/photo-1529139574466-a303027c1d8b?auto=format&fit=crop&w=900&q=80',
    model: 'Marcus Vance',
    location: 'Ginza, Tokyo',
  },
  {
    id: 4,
    title: 'Golden Hour Loom',
    category: 'Editorial',
    image: 'https://images.unsplash.com/photo-1490481651871-ab68de25d43d?auto=format&fit=crop&w=900&q=80',
    model: 'Amina Diallo',
    location: 'Marrakech, Morocco',
  },
];

const categories = ['All', 'Editorial', 'Haute Couture', 'Streetwear'];

function Fashionphotoshoot() {
  const [activeTab, setActiveTab] = useState('All');

  const filteredShoots = activeTab === 'All'
    ? shootData
    : shootData.filter((item) => item.category === activeTab);

  return (
    <main className="fps-gallery">
      {/* Header */}
      <header className="fps-header">
        <div className="fps-header__brand">
          {/* <p className="fps-header__tagline">Portfolio / SS-26</p> */}
          <h1 className="fps-header__title">Fashion Photoshoot</h1>
        </div>
        <p className="fps-header__description">
          Curated visual editorial concepts focusing on contemporary silhouettes and light study.
        </p>
      </header>

      {/* Filter Navigation */}
      <nav className="fps-filters">
        {categories.map((category) => (
          <button
            key={category}
            onClick={() => setActiveTab(category)}
            className={`fps-filters__btn ${activeTab === category ? 'fps-filters__btn--active' : ''}`}
          >
            {category}
          </button>
        ))}
      </nav>

      {/* Gallery Grid */}
      <section className="fps-grid">
        {filteredShoots.map((shoot) => (
          <article key={shoot.id} className="fps-card">
            <div className="fps-card__media">
              <img
                src={shoot.image}
                alt={shoot.title}
                className="fps-card__image"
                loading="lazy"
              />
            </div>

            <div className="fps-card__info">
              <div className="fps-card__details">
                <span className="fps-card__category">{shoot.category}</span>
                <h2 className="fps-card__title">{shoot.title}</h2>
                <p className="fps-card__model">Model: {shoot.model}</p>
              </div>
              <span className="fps-card__location">{shoot.location}</span>
            </div>
          </article>
        ))}
      </section>
    </main>
  );
}

export default Fashionphotoshoot;